// Rule-based hallucination-risk classifier for advisor review.
// Runs client-side against the finding fields Phase 1 already produces.
// This is not another AI stage — it is a data-driven screen on signals
// that correlate with unreliable output.

const MIN_QUOTE_CHARS = 20
const CONFIDENCE_FLOOR = 60
const CONFIDENCE_HIGH = 80

export function classifyRisk(finding) {
  const reasons = []
  if (!finding) {
    return { level: 'high', reasons: ['Finding is missing or malformed'] }
  }
  const confidence = finding.adjusted_confidence ?? finding.confidence ?? null
  const quote = finding.evidence_quote

  if (finding.citation_verified === false) {
    reasons.push('Citation could not be verified against the source policy')
  }
  if (!quote) {
    reasons.push('No supporting quote from the policy')
  } else if (typeof quote === 'string' && quote.trim().length < MIN_QUOTE_CHARS) {
    reasons.push('Supporting quote is too short to be meaningful')
  }
  if (confidence !== null && confidence < CONFIDENCE_FLOOR) {
    reasons.push('Specialist confidence below the safe floor')
  }

  if (reasons.length > 0) {
    return { level: 'high', reasons }
  }
  if (confidence !== null && confidence < CONFIDENCE_HIGH) {
    return { level: 'medium', reasons: ['Specialist confidence in the mid range'] }
  }
  return { level: 'low', reasons: [] }
}
